// extracted by mini-css-extract-plugin
export default {"quantity-box":"styles_quantity-box__FQ-V1","quantity":"styles_quantity__zom9R","quantity-title":"styles_quantity-title__Yd4pw","quantity-subtitle":"styles_quantity-subtitle__oPEev"};